import { apiPost } from "../_apiShim";
import { CheckInLog } from "@/types/CheckInLog";
import {
  CheckInKpi,
  CheckInTimeseriesPoint,
  CheckInTimeseriesUnit,
} from "@/types/CheckInKpi";
import { Filter } from "@/types/Filter";

const BASE_PATH = "/api/v1/check-in-logs/";

export async function getPaginatedCheckInLogs(
  eventId: string,
  searchTerm: string,
  page: number,
  pageSize: number,
  filters: Filter[],
  sortBy: string,
  sortOrder: "asc" | "desc",
): Promise<CheckInLog[]> {
  const requestBody = {
    page,
    pageSize,
    searchTerm,
    filters,
    sortBy,
    sortOrder,
  };

  return await apiPost<CheckInLog[]>(
    `${BASE_PATH}${eventId}/paginated`,
    requestBody,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getCheckInLogCount(
  eventId: string,
  filters: Filter[],
  searchTerm: string,
): Promise<number> {
  const requestBody = {
    filters,
    searchTerm,
  };

  return await apiPost<number>(
    `${BASE_PATH}${eventId}/count`,
    requestBody,
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getCheckInLogKpiSummary(
  eventId: string,
  range?: { from?: string; to?: string },
): Promise<CheckInKpi> {
  return await apiPost<CheckInKpi>(
    `${BASE_PATH}${eventId}/kpi-summary`,
    { from: range?.from, to: range?.to },
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}

export async function getCheckInLogTimeseries(
  eventId: string,
  unit: CheckInTimeseriesUnit,
  range?: { from?: string; to?: string },
): Promise<CheckInTimeseriesPoint[]> {
  return await apiPost<CheckInTimeseriesPoint[]>(
    `${BASE_PATH}${eventId}/timeseries`,
    { unit, from: range?.from, to: range?.to },
    {
      "Cache-Control": "no-store",
    },
    true,
  );
}
